<div class="row mb-3" style="margin-top:65px">
  <div class="col-12">
    <a [routerLink]="'/hourglass/tools'">
      <i class="fas fa-fw fa-lock me-2"></i>Admin Tools<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <i class="fas fa-fw fa-object-group me-2"></i>Teams Manager
  </div>
</div>
<div class="container-fluid py-3">
<div class="container-fluid py-3 teams-page">
  <div class="d-flex align-items-center justify-content-between mb-3 teams-toolbar">
    <div class="mb-0 c_bluedk module_title"><i class="fas fa-fw fa-users me-2"></i>Teams Manager</div>
    <button type="button" class="btn btn-primary btn-sm" (click)="openCreateTeam()">
      <i class="fas fa-plus me-1"></i>
      Create Team
    </button>
  </div>

  <div class="grid_sizer">
    <ag-grid-angular
      class="ag-theme-alpine"
      style="width: 100%; height: 100%; border: 0 !important"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowHeight]="28"
      [headerHeight]="32"
      [pagination]="true"
      [paginationAutoPageSize]="true"
      (gridReady)="onGridReady($event)"
      (firstDataRendered)="onFirstDataRendered()"
      (rowClicked)="onRowClicked($event)">
    </ag-grid-angular>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger mt-3">{{ errorMessage }}</div>
  <div *ngIf="loading" class="mt-3 text-muted">Loading…</div>
</div>

<div class="modal fade" id="teamEditorModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">

      <div class="modal-header">
        <h6 class="modal-title">
          <i class="fas fa-users-cog me-2"></i>
          {{ teamForm.teamID ? 'Edit Team' : 'Create Team' }}
        </h6>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeEditorModal()"></button>
      </div>

      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label">Team Name</label>
          <input type="text" class="form-control" [(ngModel)]="editorTeamName" placeholder="Enter team name" />
        </div>

        <div class="d-flex align-items-center justify-content-between mb-2">
          <label class="form-label mb-0">
            <i class="fas fa-fw fa-user-friends me-2"></i>Members
          </label>
          <div>
            <button type="button" class="btn btn-sm btn-light me-1" title="Select All" (click)="selectAllMembers()">
              <i class="fas fa-fw fa-check-double"></i>
            </button>
            <button type="button" class="btn btn-sm btn-light" title="Clear All" (click)="clearAllMembers()">
              <i class="fas fa-fw fa-times"></i>
            </button>
          </div>
        </div>

        <div class="member-list border rounded p-2" style="max-height: 55vh; overflow-y: auto;">
          <div *ngFor="let u of allUsers" class="form-check">
            <input class="form-check-input"
                   type="checkbox"
                   [id]="'u_' + u.id"
                   [checked]="teamForm.memberIds.includes(u.id)"
                   (change)="onMemberToggle(u.id, $event)" />
            <label class="form-check-label" [for]="'u_' + u.id">
              {{ u.fullName }}
            </label>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-light btn-sm" (click)="closeEditorModal()">Close</button>
        <button class="btn btn-dark btn-sm" (click)="saveTeam()">
          <i class="fas fa-save me-1"></i>Save
        </button>
      </div>

    </div>
  </div>
</div>
